import request, {METHODS} from '@/api'
import UrlConfig from "@/api/UrlConfigs";
import {trans} from "@/utils/common.ts";

/**
 * 获取枚举
 */
// 呼叫中心 - 报名城市

export function getSignUpRegion(params?: Record<string, any>) {
  return request(UrlConfig.Clue.GetCallCenterSignUpRegion, {
    method: METHODS.POST,
    data: params,
  })
}

// 呼叫中心 - 高级筛选 - 快捷时间枚举
export function getDateRangeEnum() {
  return request(UrlConfig.Clue.GetCallCenterDateRangeEnum, {
    method: METHODS.GET,
  })
}

// 呼叫中心 - 查重
export function getClueRelatives(phone) {
  return request(`${UrlConfig.Clue.getCallCenterClueRelatives}/${phone}`, {
    method: METHODS.GET,
  })
}

// 呼叫中心 - 手工录入线索
export function addClueByCallManage(data) {
  return request(UrlConfig.Clue.AddCallCenterClue, {
    method: METHODS.POST,
    data: data,
    raw: true
  })
}

// 呼叫中心 - 坐席人员列表 (根据部门编码查坐席)
export function findSeatByDeptCode(deptCode) {
  return request(`${UrlConfig.Clue.GetCallCenterSeatByDeptCode}/${deptCode}`, {
    method: METHODS.GET,
  })
}

// 呼叫中心 - 坐席部门列表
export function findSeatDeptCode(option) {
  return request(UrlConfig.Caas.FindSeatDeptCode, {
    method: METHODS.POST,
    ...option
  })
}

// 呼叫中心 - 列表
export function getlistByCall(currentPage, pageSize, params) {
  return request(`${UrlConfig.Clue.GetCallCenterPage}/${currentPage || 1}/${pageSize || 10}`, {
    method: METHODS.POST,
    data: params
  })
}

// 呼叫中心 - 列表总数
export function fetchCallListCount(params) {
  return request(UrlConfig.Clue.GetCallCenterCount, {
    method: METHODS.POST,
    data: params
  })
}

// 呼叫中心 - 列表详情
export function getDetailByCall(id) {
  return request(`${UrlConfig.Clue.GetCallCenterDetail}/${id}`, {
    method: METHODS.GET,
  })
}

// 呼叫中心 - 跟进日志列表
export function getlogList(params) {
  return request(UrlConfig.Clue.GetCallCenterLogList, {
    method: METHODS.POST,
    data: params
  })
}

// 呼叫中心 - 添加跟进日志
export function addLogList(params) {
  return request(UrlConfig.Clue.AddCallCenterLog, {
    method: METHODS.POST,
    data: params,
    raw: true
  })
}

// 呼叫中心 - 手动派单
export function dispatchByCall(params) {
  return request(UrlConfig.Clue.CallCenterDispatch, {
    method: METHODS.POST,
    data: params,
    raw: true
  })
}

// 呼叫中心 - 通话记录 - 上传录音
export function addAudio(params) {
  return request(UrlConfig.Clue.AddCallCenterAudio, {
    method: METHODS.POST,
    data: params
  })
}

/**
 * 呼叫中心--批量领取线索
 */
export const clueInfoBatchReceive = (bizOpIds: number[]) => {
  return request(UrlConfig.Clue.CallCenterClueInfoBatchReceive, {
    method: METHODS.POST,
    data: bizOpIds,
    raw: true
  })
}
// 根据工号获取呼叫中心坐席
export const getSeatAccountByWorkNumber = workNumber => {
  return request(`${UrlConfig.Clue.GetCallCenterSeatAccountByWorkNumber}/${workNumber}`, {
    method: METHODS.GET,
  })
}

// 提交有效-云客服
export const submitValidByCall = (clueId) => {
  return request(UrlConfig.Clue.ClueSubmitValid, {
    method: METHODS.POST,
    data: {
      clueId
    },
    raw: true
  })
}

// 获取客户来源
export const fetchCustomerSource = () => {
  return request(UrlConfig.Config.GetTreeWithChannelList, {
    method: METHODS.GET,
    data: {},
    params: {
      enable: true
    },
  }).then((res) => trans(res))
}